import React, { useState, useEffect, useCallback } from "react";
import { getFeaturedEvents } from "../../crud/event-listing.crud";
import ShimmerGrid from "../../revampComponents/ShimmerGrid";
import { debounce } from "lodash";
import CaseStudiesCard from "./CaseStudiesCard";
import revampData from '../../data/revampData.json';
const CaseStudiesList = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);
  const limit = 9;
  const caseStudiesData = revampData.data.listCaseStudiesFeaturedCards.data;
  const reorderByOrderNo = data => {
    return data.sort((a, b) => parseInt(a.orderNo) - parseInt(b.orderNo));
  };
  const reorderedData = reorderByOrderNo(caseStudiesData);
  // const handleSearch = (query) => {
  //   setIsSearching(false); // Hide shimmer grid once search is complete
  //   if (query === "") {
  //     setFilteredData(caseStudiesData); // Reset to all events if search query is empty
  //   } else {
  //     const filteredEvents = caseStudiesData.filter((event) =>
  //       event.event_name.toLowerCase().includes(query.toLowerCase())
  //     );
  //     setFilteredData(filteredEvents);
  //   }
  //   setCurrentPage(1); // Reset to first page on new search
  // };

  // const debouncedSearch = useCallback(
  //   debounce((value) => {
  //     handleSearch(value);
  //   }, 300),
  //   [caseStudiesData]
  // );

  // const handleSearchChange = (e) => {
  //   const value = e.target.value;
  //   setSearchQuery(value); // Update search query immediately
  //   if (value.length !== 0) {
  //     setShow(true);
  //     setIsSearching(true); // Show shimmer grid when typing starts
  //     debouncedSearch(value); // Perform the debounced search
  //   } else {
  //     handleClearSearch(); // Clear search if input is empty
  //   }
  // };

  // const handleClearSearch = () => {
  //   setSearchQuery("");
  //   setFilteredData(caseStudiesData); // Reset to show all events
  //   setShow(false); // Hide the cross icon
  //   setIsSearching(false); // Stop shimmer effect
  // };

  // Paginated events to display on the current page
  // const paginatedEvents = filteredData.slice(
  //   (currentPage - 1) * limit,
  //   currentPage * limit
  // );
  // console.log(paginatedEvents,'paginatedEvents');
  return <div className="px-sm-5 px-3 py-5 font-figtree" data-sentry-component="CaseStudiesList" data-sentry-source-file="CaseStudiesList.jsx">
      <div className="featured-events-container mb-4">
        <h6 className="featured-events-title text-uppercase">Featured Case Studies</h6>
        {/* <div className="search-bar d-flex  justify-space-between align-items-center">
          <div className="d-flex justify-space-between gap-2">
            <span className="search-icon">
              <img src="https://d2nnrpx7gk2my2.cloudfront.net/files/6706c2be839faa0008e452fb/searchmagnifyingglass.svg" alt="search icon" />
            </span>
            <input
              type="text"
              placeholder="Search Case Studies"
              value={searchQuery}
              onChange={handleSearchChange}
            /></div>
          {show && <img alt="clear search"
            onClick={handleClearSearch} // Add onClick to clear search
            style={{ cursor: "pointer" }}
            className="ml-auto mr-0" src="https://d2nnrpx7gk2my2.cloudfront.net/files/6720c9d97b8c7b0008a8cae3/Cancel.svg"  />
          }
         </div> */}
      </div>
      <div className="row d-flex">
        {isLoading || isSearching ? <ShimmerGrid count={12} /> : reorderedData.length === 0 ? <div style={{
        minHeight: "100px"
      }} className="no-resource-found text-center mt-5">
            No Case Studies Found
          </div> : reorderedData.map((caseStudies, index) => <CaseStudiesCard key={index} caseStudies={caseStudies} />)}
      </div>
      <style>
        {`
          .featured-events-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
          }
          .featured-events-title {
            font-size: 16px;
            font-weight: 600;
            color: #525252;
          }
          .search-bar {
            display: flex;
            border: 1px solid #D6D6D6;
            padding: 5px 30px 5px 10px;
            border-radius: 2px;
            gap: 5px;
            max-width: 350px;
            width: 100%;
            justify-content:space-between;
          }
          .search-bar input {
            border: none;
            outline: none;
            font-size: 16px;
            font-weight: 400;
            color: #525252;
          }
          .search-bar .search-icon {
            margin-left: 5px;
          }
          @media (max-width: 576px) {
            .featured-events-container {
              flex-direction: column;
              align-items: start;
              gap: 10px;
            }
            .search-bar {
              width: 100%;
              padding-top: 11px;
              padding-bottom: 11px;
            }
          }
        `}
      </style>
    </div>;
};
export default CaseStudiesList;